export default __webpack_public_path__ + "static/media/doctor1.692e5f7f.jpg";